export var MENSAGEM_FALHA_CARREGAR_PDF = 'Falha ao carregar documento PDF.';
var PDF_SIGNATURE = [0x25, 0x50, 0x44, 0x46];
export var extrairBytesPdf = function (arquivo) {
    var _a, _b;
    if (!arquivo) {
        return null;
    }
    var dados = Array.isArray(arquivo) || typeof arquivo === 'string' || arquivo instanceof Uint8Array ? arquivo : arquivo.data;
    if (!dados) {
        return null;
    }
    if (dados instanceof Uint8Array) {
        return dados;
    }
    if (Array.isArray(dados)) {
        return Uint8Array.from(dados);
    }
    if (typeof dados === 'string') {
        var base64 = dados.includes(',') ? (_a = dados.split(',').pop()) !== null && _a !== void 0 ? _a : '' : dados;
        if (!base64) {
            return null;
        }
        var binaryString = atob(base64);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i += 1) {
            bytes[i] = (_b = binaryString.codePointAt(i)) !== null && _b !== void 0 ? _b : 0;
        }
        return bytes;
    }
    var valores = Object.values(dados)
        .map(function (valor) { return Number(valor); })
        .filter(function (valor) { return Number.isFinite(valor); });
    return valores.length > 0 ? Uint8Array.from(valores) : null;
};
export var isPdfValido = function (bytes) {
    if (!bytes || bytes.length < PDF_SIGNATURE.length) {
        return false;
    }
    return PDF_SIGNATURE.every(function (byte, index) { return bytes[index] === byte; });
};
